import {
    NinchatAttributes,
    NinchatProperties,
} from '../../../../api/types'

export enum ErrorTypes {
    expired = 'expired'
}

export interface ChannelInviteModalProps {
    accessKey: NinchatProperties.AccessKey
    noRedirectOnCancel?: boolean
}

export interface ChannelInviteModalViewProps {
    describeError: {
        title: string
        text: string
        type?: ErrorTypes
    } | null
    joinError: {
        title: string
        text: string
    } | null
    channelAttrs: NinchatAttributes.NinchatChannelAttributes | null
    realmAttrs: (NinchatAttributes.NinchatRealmAttributes) | null
    userAttrs: (NinchatAttributes.NinchatUserAttributes) | null
    userId?: string,
    realmMember?: boolean
    channelUnsilence?: boolean
    onAccept: () => void
    onDecline: () => void
}
